const CloseButton = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="1"
        width="23"
        height="23"
        rx="11.5"
        fill="url(#paint0_linear_570_3259)"
      />
      <rect x="0.5" y="1" width="23" height="23" rx="11.5" stroke="black" />
      <path
        d="M18.125 12C20.3341 12 22.1959 10.1405 21.3356 8.10573C20.8385 6.93001 20.1162 5.84905 19.1961 4.92893C17.3207 3.05357 14.7772 2 12.125 2C9.47284 2 6.9293 3.05357 5.05393 4.92893C4.13381 5.84905 3.41152 6.93001 2.91443 8.10573C2.05413 10.1405 3.91586 12 6.125 12L12.125 12H18.125Z"
        fill="white"
        fillOpacity="0.35"
      />
      <g filter="url(#filter0_d_570_3259)">
        <path
          d="M14.145 12.5004L18.1667 8.47869C18.6111 8.03433 18.6111 7.31391 18.1667 6.87025L17.6306 6.3341C17.1861 5.8896 16.4657 5.8896 16.022 6.3341L12.0004 10.3557L7.97869 6.33327C7.53433 5.88891 6.81391 5.88891 6.37025 6.33327L5.83327 6.86942C5.38891 7.31391 5.38891 8.03433 5.83327 8.478L9.85569 12.5004L5.8341 16.522C5.3896 16.9665 5.3896 17.6869 5.8341 18.1306L6.37025 18.6667C6.81461 19.1111 7.53503 19.1111 7.97869 18.6667L12.0004 14.645L16.022 18.6667C16.4665 19.1111 17.1869 19.1111 17.6306 18.6667L18.1667 18.1306C18.6111 17.6861 18.6111 16.9657 18.1667 16.522L14.145 12.5004Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_570_3259"
          x="4"
          y="4.5"
          width="16.5"
          height="17"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.5" dy="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_570_3259"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_570_3259"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_570_3259"
          x1="0"
          y1="0.5"
          x2="24"
          y2="24.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0000" />
          <stop offset="0.490385" stopColor="#D70000" />
          <stop offset="1" stopColor="#FF6F6F" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CloseButton;
